import { fromZonedTime, toZonedTime } from 'date-fns-tz';
import { format, set } from 'date-fns';
/**
* This function transform date in format establecido
@param {Date} date - date
@param {String} pattern - pattern transform date
*/
const parseDate = (date, pattern = 'dd/MM/yyyy') => {
  const timezone = localStorage.getItem('timezone') || 'Australia/Victoria'; // 'Australia/Victoria

  return format(toZonedTime(date, timezone), pattern);
};


/**
 * Set start date
 * @param {string | Date} date - The date.
 * @returns {Date} The date.
 */
const setStarDate = (date) =>
  set(new Date(date), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });

/**
 * Set start date
 * @param {string | Date} date - The date.
 * @returns {Date} The date.
 */
const setEndDate = (date) =>
  set(new Date(date), {
    hours: 23,
    minutes: 59,
    seconds: 59,
    milliseconds: 999
  });


/**
 * @description Get UTC Dates
 * @param {string | Date} start - The start date.
 * @param {string | Date} end - The end date.
 * @param {string} TZ - The timezone.
 * @returns {Object} The start and end date.
 */
const getUTCDates = (start, end, TZ = 'UTC') => {
  const currentStart = setStarDate(toZonedTime(start, TZ));
  const dstart = fromZonedTime(currentStart, TZ);

  const currentEnd = setEndDate(toZonedTime(end, TZ));
  const dend = fromZonedTime(currentEnd, TZ);
  return {
    start: dstart,
    end: dend
  };
};

/**
 * Format a date in a specific timezone to a string in the format 'dd/MMM/yyyy'.
 * If the date is invalid, return the placeholder string.
 *
 * @param {Date} date - date to format
 * @param {String} [timezone] - timezone to use for formatting
 * @param {String} [placeholder=''] - string to return if date is invalid
 * @returns {String} - formatted date string
 */
const formatDate = (date, timezone = 'Australia/Victoria', placeholder = '') => {
  try {
    if (date) {
      const utcToTimezone = toZonedTime(date, timezone);

      const day = String(utcToTimezone.getDate()).padStart(2, '0');
      const month = utcToTimezone.toLocaleString('en-US', { month: 'short' });
      const year = utcToTimezone.getFullYear();

      return `${day}/${month}/${year}`;
    }

    return placeholder;
  } catch (error) {
    return placeholder;
  }
};

const formatDuration = (startDate, endDate) => {
  const durationMs = endDate - startDate;
  const seconds = Math.floor((durationMs / 1000) % 60);
  const minutes = Math.floor((durationMs / (1000 * 60)) % 60);
  const hours = Math.floor((durationMs / (1000 * 60 * 60)) % 24);
  if (hours === 0 && minutes === 0 && seconds === 0) {
    return '0s';
  }
  if (hours === 0 && minutes === 0) {
    return `${seconds}s`;
  }
  if (hours === 0) {
    return `${minutes}m ${seconds}s`;
  }
  
  return `${hours}h ${minutes}m ${seconds}s`;
}

export { parseDate, formatDate, getUTCDates, formatDuration };
